import * as React from 'react';

import { Link } from '@gitbook/react-uikit';
import {
    Button,
    LoadingIndicator,
    PageSplitDescription,
    PageSplitTitle,
} from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { MFAScreenModal, useHideSplashscreen } from '../../Components';
import { useAuthOperations } from '../../state';
import { LoginScreenLayout } from './LoginScreenLayout';

/**
 * Step to apply the result of the authentication redirect flow.
 * This step is not really needed as Firebase will authenticate in the background anyway,
 * but we use to ensure we track the event in the analytics.
 */
export function StepApplyAuthRedirect(props: { onDone: () => void }): React.ReactElement {
    const onDone = useEventCallback(props.onDone);

    useHideSplashscreen(0);

    const { mfa, signInWithRedirectResult } = useAuthOperations();

    React.useEffect(() => {
        // Attempt to sign-in with the redirect result.
        signInWithRedirectResult().then((user) => {
            if (user) {
                onDone();
            }
        });
    }, [onDone, signInWithRedirectResult]);

    if (mfa) {
        return <MFAScreenModal mfa={mfa} onDone={onDone} />;
    }

    const onReload = () => {
        // Redirect to the root to strip all query string.
        window.location.href = '/';
    };

    return (
        <LoginScreenLayout>
            <PageSplitTitle>Authenticating</PageSplitTitle>
            <PageSplitDescription>You are being authenticated on GitBook.</PageSplitDescription>
            <Button
                leadingIcon={LoadingIndicator}
                disabled
                kind="primary"
                label="Continue"
                size="large"
            />
            <Link kind="in-text-muted" onPress={() => onReload()}>
                Refresh the page
            </Link>
        </LoginScreenLayout>
    );
}
